import React from 'react';
import BlogDetailBanner from "../../assets/image/blog-detail-banner.jpg";
import DetailImage from "../../assets/images/blog1.webp";
import Image from "../../components/elements/Image";
import { Link } from "react-router-dom";

const BlogDetails = () => {

  return (
    <>
      <section className="w-full relative aspect-[5/1] overflow-hidden after:absolute after:!bg-black/60 after:w-full after:h-full after:content after:top-0">
        <Image src={BlogDetailBanner} alt="" classes="object-cover object-top" />

        <div className="text-white text-sm absolute bottom-0 z-10 bg-black/70 py-4 w-full">
          <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
            <ol className="flex items-center justify-center space-x-2">
              <li>
                <Link to="/" className="hover:text-primary transition">Home</Link>
              </li>
              <li>/</li>
              <li>
                <Link to="/blogs" className="hover:text-primary transition">Blog</Link>
              </li>
              <li>/</li>
              <li className="text-slate-300">Introducing the new Trihurst Tech</li>
            </ol>
          </div>
        </div>
      </section>

      <section className="mt-24">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-7 space-y-10">
              <div className="aspect-[6/3] rounded-xl overflow-hidden">
                <Image src={DetailImage} alt={""} classes="object-cover" />
              </div>
              <div className="w-full">
                <h1 className="font-medium text-white text-xl capitalize">Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.</h1>
                <div className="text-white text-sm mt-5"><p>At Trihurst Tech, we’re redefining the way you experience crypto transactions. Our brand-new Checkout system is designed with one goal in mind: making buying and selling digital assets simpler, quicker, and smarter than ever before. No more waiting around for sluggish confirmations. Trihurst Checkout is optimized for lightning-fast transactions, ensuring your crypto moves as quickly as you do.</p>
                  <p>With an intuitive interface and intelligent order handling, Trihurst Checkout adapts to your needs. Whether you’re a seasoned trader or just starting your crypto journey, our platform provides a seamless flow from deposit to purchase.</p>
                  <p>Every transaction is backed by enterprise-grade encryption and multi-layer security protocols. Your funds and personal data are always protected — giving you peace of mind while you trade.</p>
                  <p>Support for multiple cryptocurrencies and payment options means you can trade the way you want, no matter where you are.</p>
                </div>
              </div>
            </div>
            <div className="col-span-5"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;